import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChecklistOutline24 = function SvgChecklistOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.515 16.55.674.678L6.21 20.23l-1.536-1.548.674-.68.862.87 2.305-2.323zm1.162 3.697h8.745v-.924H9.677v.924zM8.515 12.32l.674.678L6.21 16l-1.536-1.55.674-.678.862.87 2.305-2.322zm1.162 3.697h8.745v-.925H9.677v.925zM8.515 8.089l.674.68-2.979 3-1.536-1.548.674-.679.862.87L8.515 8.09zm1.162 3.698h8.745v-.925H9.677v.925zm11.37 11.253H2.953V3.36H5.81v2.4h.952v-2.4h2.857v2.4h.952v-2.4h2.858v2.4h.952v-2.4h2.857v2.4h.953v-2.4h2.857v19.68zM18.19 2.4V0h-.952v2.4h-2.857V0h-.952v2.4H10.57V0h-.95v2.4H6.762V0H5.81v2.4H2V24h20V2.4h-3.81z",
    fill: "currentColor"
  })));
};

var ChecklistOutline24Svg = SvgChecklistOutline24;

export { ChecklistOutline24Svg as default };
//# sourceMappingURL=ChecklistOutline24.svg.js.map
